import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
function FadeInUp({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 40
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.7,
    delay
  }} data-id="element-310">
      {children}
    </motion.div>;
}
export function ProofSection() {
  return <section className="w-full py-20 px-4 relative overflow-hidden" style={{
    background: 'radial-gradient(ellipse at 50% 50%, #0f1f3d 0%, #0a1628 70%)'
  }} data-id="element-311">
      {/* Gold glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full blur-3xl opacity-5 pointer-events-none" style={{
      background: 'var(--color-gold)'
    }} data-id="element-312" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-313">
        <FadeInUp data-id="element-314">
          <div className="text-center mb-14" data-id="element-315">
            <div className="section-divider mb-6" data-id="element-316">
              <span className="ornament" data-id="element-317">◈</span>
            </div>
            <h2 className="font-heading font-700 text-4xl md:text-5xl mb-4" style={{
            color: 'var(--color-cream)'
          }} data-id="element-318">
              Lo Que Sucede en los
              <span className="block italic" style={{
              color: 'var(--color-gold)'
            }} data-id="element-319">
                Primeros 7 Días
              </span>
            </h2>
          </div>
        </FadeInUp>

        {/* Results grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14" data-id="element-320">
          <FadeInUp delay={0.1} data-id="element-321">
            <div className="rounded-xl p-6 text-center" style={{
            background: 'rgba(15, 31, 61, 0.8)',
            border: '1px solid rgba(201, 168, 76, 0.25)'
          }} data-id="element-322">
              <div className="text-4xl mb-3" data-id="element-323">🫃</div>
              <h3 className="font-heading font-600 text-lg mb-2" style={{
              color: 'var(--color-gold)'
            }} data-id="element-324">
                Hinchazón Abdominal
              </h3>
              <p className="font-body text-sm leading-relaxed" style={{
              color: 'var(--color-cream-dim)'
            }} data-id="element-325">
                Desaparece la hinchazón que te ha acompañado por años. Tu
                digestión se normaliza.
              </p>
            </div>
          </FadeInUp>

          <FadeInUp delay={0.2} data-id="element-326">
            <div className="rounded-xl p-6 text-center" style={{
            background: 'rgba(15, 31, 61, 0.8)',
            border: '1px solid rgba(74, 158, 255, 0.25)'
          }} data-id="element-327">
              <div className="text-4xl mb-3" data-id="element-328">🧠</div>
              <h3 className="font-heading font-600 text-lg mb-2" style={{
              color: 'var(--color-blue-glow)'
            }} data-id="element-329">
                Claridad Mental
              </h3>
              <p className="font-body text-sm leading-relaxed" style={{
              color: 'var(--color-cream-dim)'
            }} data-id="element-330">
                Una claridad mental que no sentías en años. La "niebla" se
                disipa y tu mente vuelve a ser aguda.
              </p>
            </div>
          </FadeInUp>

          <FadeInUp delay={0.3} data-id="element-331">
            <div className="rounded-xl p-6 text-center" style={{
            background: 'rgba(15, 31, 61, 0.8)',
            border: '1px solid rgba(74, 124, 89, 0.3)'
          }} data-id="element-332">
              <div className="text-4xl mb-3" data-id="element-333">😴</div>
              <h3 className="font-heading font-600 text-lg mb-2" style={{
              color: 'var(--color-olive)'
            }} data-id="element-334">
                Sueño Profundo
              </h3>
              <p className="font-body text-sm leading-relaxed" style={{
              color: 'var(--color-cream-dim)'
            }} data-id="element-335">
                La capacidad de dormir 7 horas seguidas sin interrupciones. Tu
                cuerpo descansa de verdad.
              </p>
            </div>
          </FadeInUp>
        </div>

        <FadeInUp delay={0.4} data-id="element-336">
          <div className="rounded-xl p-8 text-center relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, rgba(201, 168, 76, 0.06), rgba(15, 31, 61, 0.9))',
          border: '1px solid rgba(201, 168, 76, 0.3)'
        }} data-id="element-337">
            <div className="absolute top-0 left-0 right-0 h-px" style={{
            background: 'linear-gradient(90deg, transparent, var(--color-gold), transparent)'
          }} data-id="element-338" />
            <p className="font-heading text-2xl md:text-3xl italic font-400 leading-relaxed mb-4" style={{
            color: 'var(--color-cream)'
          }} data-id="element-339">
              "No es magia, es tu biología respondiendo al combustible
              correcto."
            </p>
            <p className="font-body text-base" style={{
            color: 'var(--color-cream-dim)'
          }} data-id="element-340">
              La mayoría de los usuarios reportan estos cambios en los primeros
              7 días de aplicar la Bio-Restauración Génesis.
            </p>
          </div>
        </FadeInUp>
      </div>
    </section>;
}